export default "__VITE_ASSET__DCX8Kw78__"